export class ImovelVideo {
  id: string;
  tipo: number;
  codigo: string;
  videoUrl: string;
  fotoPequenaUrl: string;
}
